module.exports = __webpack_public_path__ + "static/img/downlogo.f415b8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/downlogo.png
// module id = pu3/
// module chunks = 170